import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
    HeaderComponent,
    FooterComponent,
    NotFoundComponent,
    PdfViewerComponent
} from './components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

const MODULES = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgxExtendedPdfViewerModule
];

const COMPONENTS = [
    HeaderComponent,
    FooterComponent,
    NotFoundComponent,
    PdfViewerComponent
];

const PIPES = [
];

@NgModule({
    imports: [
        NgbModule,
        ...MODULES,
    ],
    exports: [
        ...MODULES,
        ...PIPES,
        ...COMPONENTS,
    ],
    declarations: [
        ...COMPONENTS,
        ...PIPES,
    ],
})
export class ThemeModule {
    static forRoot(): ModuleWithProviders<ThemeModule> {
        return {
            ngModule: ThemeModule,
            providers: [],
        };
    }
}
